//import { toastrCustom } from './toastr.factory';
import { EnumErrorType, EnumNoPermissionErrorSource } from '@/common/models/enum'
import { i18n } from '@/plugins/i18n'
import store from '@/store'

/**
 * Format component's name
 *
 * @param {*} vm {Compoent}
 */
const formatComponentName = (vm: any) => {
  if (vm.$root === vm) {
    return 'root'
  }
  const name = vm._isVue
    ? (vm.$options && vm.$options.name) ||
      (vm.$options && vm.$options._componentTag)
    : vm.name
  const errComponent = name ? 'Component "' + name + '"' : 'anonymous component'
  const errFile =
    vm._isVue && vm.$options && vm.$options.__file ? vm.$options && vm.$options.__file : ''
  return `${errComponent} at ${errFile}`
}

/**
 * Global error handler
 *
 * @param {*} err {Error trace}
 * @param {*} vm {Component in which error occured}
 * @param {*} info {Vue specific error information such as lifecycle hooks, events etc}
 */
const errorHandler = (err: any, vm: any, info: any) => {
  if (info !== 'errorCaptured hook') {
    const errorType = err.errorType
    let err4Backend
    let errMsg: string
    switch (errorType) {
    case EnumErrorType.HttpInvalidTokenError:
      err4Backend = typeof err.toServerString === 'function' ? err.toServerString() : err
      errMsg = `"${err4Backend}" from ${formatComponentName(vm)} (${info})`
      vm.$JL.fatal(errMsg)
      break
    case EnumErrorType.NoPermissionError: {
      // handle error msg
      let modalTitle: string
      let modalContent: string
      const _t: any = i18n.global
      if (store.getters.errorSource === EnumNoPermissionErrorSource.FromURL ) {
        modalTitle = _t.tc('common.error.noPermissionType0Title1')
        modalContent = _t.tc('common.error.noPermissionType0Msg')
      } else {
        modalTitle = _t.tc('common.error.noPermissionType1Title1') + _t.tc('menu.' + store.getters.errorPageName) + _t.tc('common.error.noPermissionType1Title2')
        modalContent = _t.tc('common.error.noPermissionType1Msg')
      }
      vm.$Modal.warning({
        title: modalTitle,
        content: modalContent,
        okText: _t.tc('action.confirm'),
        closable: false,
      })
      err4Backend = typeof err.toServerString === 'function' ? err.toServerString() : err
      errMsg = `"${err4Backend}" source: ${store.getters.errorSource} from ${formatComponentName(vm)}`
      vm.$JL.error(errMsg)

      store.commit('setErrorSource', EnumNoPermissionErrorSource.FromButton)
      break
    }
    default:
      err4Backend = typeof err.toServerString === 'function' ? err.toServerString() : err
      errMsg = `"${err4Backend}" from ${formatComponentName(vm)} (${info})`
      //toastrCustom.error(err);
      //console.log(err);
      vm.$JL.error(errMsg)
      // console.log(err)
      // console.log(info)
    }
  }
}

export { errorHandler }
